var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchangeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5C2.75 4.86193 2.86193 4.75 3 4.75H5C5.41421 4.75 5.75 4.41421 5.75 4C5.75 3.58579 5.41421 3.25 5 3.25H3C2.0335 3.25 1.25 4.0335 1.25 5V7C1.25 7.41421 1.58579 7.75 2 7.75C2.41421 7.75 2.75 7.41421 2.75 7V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 4.44772 6.44772 4 7 4H21C21.5523 4 22 4.44772 22 5V13C22 13.5523 21.5523 14 21 14H19.5V11C19.5 9.61929 18.3807 8.5 17 8.5H6V5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.25C21.1381 19.25 21.25 19.1381 21.25 19V17C21.25 16.5858 21.5858 16.25 22 16.25C22.4142 16.25 22.75 16.5858 22.75 17V19C22.75 19.9665 21.9665 20.75 21 20.75H19C18.5858 20.75 18.25 20.4142 18.25 20C18.25 19.5858 18.5858 19.25 19 19.25H21Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 10.4477 2.44772 10 3 10H17C17.5523 10 18 10.4477 18 11V19C18 19.5523 17.5523 20 17 20H3C2.44772 20 2 19.5523 2 19V11ZM3.25 15C3.25 15.4142 3.58579 15.75 4 15.75H6C6.41421 15.75 6.75 15.4142 6.75 15C6.75 14.5858 6.41421 14.25 6 14.25H4C3.58579 14.25 3.25 14.5858 3.25 15ZM14 14.25C13.5858 14.25 13.25 14.5858 13.25 15C13.25 15.4142 13.5858 15.75 14 15.75H16C16.4142 15.75 16.75 15.4142 16.75 15C16.75 14.5858 16.4142 14.25 16 14.25H14ZM12 15C12 13.8954 11.1046 13 10 13C8.89543 13 8 13.8954 8 15C8 16.1046 8.89543 17 10 17C11.1046 17 12 16.1046 12 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeAlt);
export default __webpack_public_path__ + "static/media/exchange-alt.aa28ee7f31b0b36bc7a444ed1bd0c488.svg";
export { ForwardRef as ReactComponent };